export const environment = {
  production: true,
  version: '1.0.0',
  basePath: '/siu-formazione/api',
  authUrl: 'https://portaleformazione-auth.regione.abruzzo.it/',
  authRealm: 'siu-formazione',
  authClientId: 'siu-formazione-spa',
};
